import * as React from 'react';
import { useRouter } from 'next/router';
import { useUnsavedChanges } from '@/context/UnsavedChangesContext';
import useModal from '@/hooks/useModal';
import { Typography } from '../typography';
import { Button } from '../button';
import { ModalHeader } from '@/components/dashboard';

export function UnsavedChangesModal() {
	const router = useRouter();
	const { Modal, hide, show } = useModal();
	const {
		isModalOpen,
		setIsModalOpen,
		pendingRoute,
		setPendingRoute,
		setHasUnsavedChanges,
	} = useUnsavedChanges();

	const handleConfirm = async () => {
		if (!pendingRoute) return;

		setHasUnsavedChanges(false);
		setIsModalOpen(false);
		hide();

		await router.push(pendingRoute);
		setPendingRoute(null);
	};

	const handleCancel = () => {
		setIsModalOpen(false);
		hide();
		setPendingRoute(null);
	};

	React.useEffect(() => {
		if (isModalOpen) show();
	}, [isModalOpen]);

	return (
		<Modal
			classNameCardContainer="max-w-[532px]"
			withXButton
			onClose={handleCancel}
			closeIconTopPosition="32px"
			title={<ModalHeader title="Unsaved Information" />}
		>
			<Typography type="regular-16" className="text-center px-10">
				The information you have entered has not been saved. Are you sure you
				wish to leave?
			</Typography>
			<div className="flex items-center gap-x-2 justify-center mt-8">
				<Button
					label="Stay"
					decoration="secondary"
					size="fit"
					onClick={handleCancel}
				/>
				<Button
					label="Leave"
					decoration="primary"
					size="fit"
					onClick={handleConfirm}
				/>
			</div>
		</Modal>
	);
}
